export const DRAWER_CONFIG = {
  width: 400,
  placement: 'left' as const,
} as const;

export const CALL_STATUS_COLORS = {
  missed: '#ff6b6b',
  answered: '#54CA2B',
} as const;

export const CARD_STYLES = {
  marginBottom: '1rem',
  borderRadius: '8px',
} as const;

export const ICON_STYLES = {
  width: '16px',
  height: '16px',
} as const;
